import { Document } from '@/services/documents-service/documents-service.types';

export const generateDataSource = (data: Document[]) => {
  return data?.map((element) => ({
    key: element.id,
    ...element,
  }));
};
